export default __webpack_public_path__ + "static/frame-004-60a3a078bf13e4a567ba36a36dde89cd.png";